export default __webpack_public_path__ + "static/media/email-sent.ce90dab8.svg";